// Classes communes aux champs du form-builder dans le thème kms7
export const fieldClassName =
  "h-12 rounded border-[#AFB1AB] bg-[#F5F6F7] px-4 text-base text-black placeholder:text-black/40 transition-colors focus-visible:border-primary focus-visible:bg-white focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:ring-offset-0";
